import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { AppointmentComponent } from './appointment/appointment.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SlotsComponent } from './slots/slots.component';
import { GlobalService } from './global.service';
import { BookAppointmentComponent } from './book-appointment/book-appointment.component';
import { SucessComponent } from './sucess/sucess.component';
import { FilterPipe } from './Pipes/filter.pipe';
import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { DatePipe } from '@angular/common';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { PaymentComponent } from './payment/payment.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { TimeFormatPipe } from './Pipes/time-format.pipe';
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'red',
  bgsPosition: POSITION.bottomCenter,
  bgsSize: 40,
  bgsType: SPINNER.rectangleBounce, // background spinner type
  fgsType: SPINNER.chasingDots, // foreground spinner type
  pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
  pbThickness: 5, // progress bar thickness
};

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    AppointmentComponent,
    SlotsComponent,
    BookAppointmentComponent,
    SucessComponent,
    FilterPipe,
    PaymentComponent,
    TimeFormatPipe
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    BsDatepickerModule.forRoot(),
    ReactiveFormsModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),    
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'counter', component: CounterComponent },
      { path: 'fetch-data', component: FetchDataComponent },
      { path: 'Appointment/:id/:value', component: AppointmentComponent },
      { path: 'Slots', component: SlotsComponent },
      { path: 'Book', component: BookAppointmentComponent },
      { path: 'Sucess', component: SucessComponent },
      { path: 'Payment', component: PaymentComponent }

    ]),
    FilterPipeModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
  ],
  providers: [GlobalService, DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts